export function copperToCoinParts(value) {
  const totalCopper = Math.max(0, Number(value) || 0);
  const gold = Math.floor(totalCopper / 10000);
  const silver = Math.floor((totalCopper % 10000) / 100);
  const copper = totalCopper % 100;

  return {
    totalCopper,
    gold,
    silver,
    copper,
  };
}

export function formatCoinText(value) {
  const { gold, silver, copper } = copperToCoinParts(value);
  return `${gold}g ${silver}s ${copper}c`;
}
